import React from 'react';
import '../styles/thingsdiff.css';
import thingsdiffImg from '../../../../assets/company/aboutus/thingsdiff_img.png';

const ThingsDiff = () => {
    return (
        <section className="thingsdiff-section">
            <div className="thingsdiff-container">
                <div className="thingsdiff-content">
                    <h2 className="thingsdiff-title">
                        Synectiks provides all that business need
                    </h2>
                    <p className="thingsdiff-description">
                        At Synectiks, we’ve always believed in doing things differently. Since 2006, we have helped organizations strengthen their technology foundations through secure cloud infrastructure, cyber protection, and digital transformation services.
                        Our mission is clear: empower businesses to secure, migrate, modernize, and innovate with speed and confidence-so they can scale smarter, operate more efficiently, and stay ahead in an increasingly complex digital world.
                        From protecting endpoints against ransomware to enabling cloud continuity, modern workplace productivity, and AI-powered transformation, Synectiks delivers the resilience and agility modern enterprises need to thrive.
                    </p>
                </div>
                <div className="thingsdiff-image">
                    <img
                        src={thingsdiffImg}
                        alt="We’ve always done things differently"
                        className="thingsdiff-img"
                    />
                </div>
            </div>
        </section>
    );
};

export default ThingsDiff;
